//angular imports
import { 
  Signal, 
  WritableSignal, 
  computed, 
  signal 
} from "@angular/core";

//local imports
import { IMenu } from "@app/core";
import { IListItem, ListItem, Messenger } from "@app/shared";
import {
  AbstractCategoryModel,
  TypedNavItem
} from "@app/catalog-common";

export abstract class AbstractCategoryNavModel<TCategory extends AbstractCategoryModel>
  extends TypedNavItem<ListItem<TCategory>>
  implements IMenu
{
  public subMenu?: WritableSignal<IMenu> = signal<IMenu>(null);

  constructor(
    protected messenger: Messenger,
    items: Signal<TCategory[]>,
  ) {
    super();

    this.items = computed(() =>
      items()
      .sort((a,b)=>a.name() > b.name() ? 1 : -1)
      .map((item) => item.toListItem$(item.isChecked)),
    );
  }

  public abstract select(item: IListItem): void;
}
